import { useParams, Navigate } from "react-router-dom";
import { ALL_LOCATIONS, LocationContext } from "@/lib/locations";
import { WaitlistPopup } from "@/components/WaitlistPopup";
import Blog from "./Blog";

/**
 * Wraps the Blog page with the correct LocationContext
 * based on the :region URL param (e.g. /locations/contra-costa/blog)
 */
const RegionBlogPage = () => {
  const { region } = useParams<{ region: string }>();

  const locationData = ALL_LOCATIONS.find(loc => loc.slug === region);

  if (!locationData) return <Navigate to="/blog" replace />;

  return (
    <LocationContext.Provider value={locationData}>
      <WaitlistPopup />
      <Blog />
    </LocationContext.Provider>
  );
};

export default RegionBlogPage;
